import { MutationTree } from 'vuex';
import AuthState from '@/types/store/auth/AuthState';

const mutations: MutationTree<AuthState> = {};

export default mutations;
